export const SINGLE_LOAN_REQUEST_START = 'SINGLE_LOAN_REQUEST_START';
export const SINGLE_LOAN_REQUEST_SUCCESS =
  'SINGLE_LOAN_REQUEST_SUCCESS';
export const SINGLE_LOAN_REQUEST_ERROR = 'SINGLE_LOAN_REQUEST_ERROR';
export const SINGLE_LOAN_REQUEST_END = 'SINGLE_LOAN_REQUEST_END';
